"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SortIcon", {
  enumerable: true,
  get: function get() {
    return _SortIcon["default"];
  }
});
Object.defineProperty(exports, "ExpansionButtonHolder", {
  enumerable: true,
  get: function get() {
    return _ExpandButton.ExpansionButtonHolder;
  }
});
Object.defineProperty(exports, "SubrowButton", {
  enumerable: true,
  get: function get() {
    return _SubrowButton["default"];
  }
});
Object.defineProperty(exports, "HeaderCell", {
  enumerable: true,
  get: function get() {
    return _HeaderCell["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SortIcon = _interopRequireWildcard(require("./SortIcon"));
var _ExpandButton = require("./ExpandButton");
var _SubrowButton = _interopRequireWildcard(require("./SubrowButton"));
var _ColumnPropTypes = _interopRequireDefault(require("./ColumnPropTypes"));
var _HeaderCell = _interopRequireDefault(require("./HeaderCell"));
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var HeaderDiv = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex align-items-end pl-2 bcr-table-header"
  };
}).withConfig({
  displayName: "Header__HeaderDiv",
  componentId: "la6gfs-0"
})(["height:", "px;width:100%;min-width:", "px;border-bottom:1px solid ", ";background:", ";"], function (props) {
  return props.height;
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["almost-white"];
});
var Header = function Header(_ref) {
  var headerHeight = _ref.headerHeight,
    sortColumn = _ref.sortColumn,
    sortDirection = _ref.sortDirection,
    sortFunction = _ref.sortFunction,
    columns = _ref.columns,
    expansion = _ref.expansion,
    subrows = _ref.subrows,
    expandAll = _ref.expandAll,
    anyAreExpanded = _ref.anyAreExpanded,
    columnSizes = _ref.columnSizes,
    minWidth = _ref.minWidth,
    displayExpansionButton = _ref.displayExpansionButton;
  var handleSort = function handleSort(canSort, key) {
    if (canSort) {
      var direction;
      if (sortColumn !== key) {
        direction = _SortIcon.ASC;
      } else if (sortDirection === _SortIcon.ASC) {
        direction = _SortIcon.DESC;
      } else {
        direction = _SortIcon.NO_DIRECTION;
      }
      var newKey = direction === _SortIcon.NO_DIRECTION ? "" : key;
      sortFunction(newKey, direction);
    }
  };
  return _react["default"].createElement(HeaderDiv, {
    height: headerHeight,
    minWidth: minWidth
  }, !!expansion && displayExpansionButton && _react["default"].createElement(_ExpandButton.ExpansionButtonHolder, null), !!subrows && _react["default"].createElement(_SubrowButton.SubRowButtonHolder, null, _react["default"].createElement(_SubrowButton["default"], {
    expanded: anyAreExpanded,
    onClick: expandAll
  })), columns.map(function (col, index) {
    var name = col.name,
      key = col.key,
      sortable = col.sortable,
      _col$cellClass = col.cellClass,
      cellClass = _col$cellClass === void 0 ? "" : _col$cellClass;
    var columnId = "".concat(Math.floor(Math.random() * 10000), "-").concat(key);
    var width = !!columnSizes[index] ? columnSizes[index] : col.width;
    return _react["default"].createElement(_HeaderCell["default"], {
      id: columnId,
      key: columnId,
      width: width,
      headerHeight: headerHeight,
      sortable: sortable,
      onClick: function onClick() {
        return handleSort(sortable, key);
      },
      sorted: sortColumn === key,
      backgroundColor: col.headerBackgroundColor,
      name: name,
      sortDirection: sortDirection,
      cellClass: cellClass
    });
  }));
};
Header.propTypes = {
  columns: _ColumnPropTypes["default"].isRequired,
  headerHeight: _propTypes["default"].number,
  columnSizes: _propTypes["default"].arrayOf(_propTypes["default"].number),
  subrows: _propTypes["default"].bool,
  minWidth: _propTypes["default"].number,
  expansion: _propTypes["default"].bool,
  sortColumn: _propTypes["default"].string,
  sortDirection: _propTypes["default"].oneOf([_SortIcon.ASC, _SortIcon.DESC, _SortIcon.NO_DIRECTION]),
  sortFunction: _propTypes["default"].func,
  expandAll: _propTypes["default"].func,
  anyAreExpanded: _propTypes["default"].bool,
  displayExpansionButton: _propTypes["default"].bool
};
Header.defaultProps = {
  headerHeight: 35,
  minWidth: 50,
  columnSizes: [],
  sortColumn: null,
  sortDirection: null,
  sortFunction: function sortFunction() {},
  subrows: false,
  expansion: false,
  expandAll: function expandAll() {},
  anyAreExpanded: false,
  displayExpansionButton: true
};
Header.HeaderCell = _HeaderCell["default"];
var _default = Header;
exports["default"] = _default;